"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var quill_delta_1 = __importDefault(require("quill-delta"));
/**
 * The custom blots that we defined in quill-decorator.js
 */
var CustomBlot;
(function (CustomBlot) {
    CustomBlot["PipedText"] = "PipedText";
    CustomBlot["Hyperlink"] = "Hyperlink";
})(CustomBlot || (CustomBlot = {}));
var MATCHER_CONFIGS = (_a = {},
    _a[CustomBlot.PipedText] = {
        name: 'piped-text',
        selector: '.piped-text-highlight',
        attribute: 'ptAttrs'
    },
    _a[CustomBlot.Hyperlink] = {
        name: 'hyperlink',
        selector: '.hyperlink-highlight',
        attribute: 'hlAttrs'
    },
    _a);
/**
 * Class to provide our custom clipboard matchers for our custom blots
 */
var QuillClipboardMatchers = /** @class */ (function () {
    function QuillClipboardMatchers() {
    }
    QuillClipboardMatchers.prototype.getMatchers = function (options) {
        if (options === void 0) { options = {}; }
        var matchers = [];
        if (options.pipedText) {
            matchers.push(createQuillMatcher(CustomBlot.PipedText));
        }
        if (options.hyperlinks) {
            matchers.push(createQuillMatcher(CustomBlot.Hyperlink));
        }
        return matchers;
    };
    return QuillClipboardMatchers;
}());
exports.default = QuillClipboardMatchers;
function createQuillMatcher(blot) {
    var _a = MATCHER_CONFIGS[blot], name = _a.name, selector = _a.selector, attribute = _a.attribute;
    var attributeLowerCase = attribute.toLowerCase();
    var handler = function (node, delta) {
        var _a, _b;
        // use lowercase because browsers force attributes to be lowercase
        if (lodash_1.default.includes(node.getAttributeNames(), attributeLowerCase)) {
            var valueString = node.getAttribute(attributeLowerCase);
            try {
                return new quill_delta_1.default().insert((_a = {},
                    _a[name] = (_b = {},
                        _b[attribute] = JSON.parse(valueString),
                        _b),
                    _a));
            }
            catch (error) {
                console.error('Failed to parse attributes', name, error);
                return delta;
            }
        }
    };
    return [selector, handler];
}
(function (angularModule) {
    angularModule.service('pr.quillClipboardMatchers', QuillClipboardMatchers);
})(angular_1.module('qualtrics.pr'));
